// Preprocess the HTML before rendering it inside the sandboxed iframe.
// Removes any elements whose id starts with 'titan-profile-sidebar' or 'enhancer-container-element'.
// This is to prevent the profile sidebar from being rendered inside the iframe.
// This still does not execute any scripts.
export const sanitizeHtmlForIframe = (input: string): string => {
    try {
        const container = document.createElement('div');
        container.innerHTML = input;
        const toRemove = container.querySelectorAll(
            '[id^="titan-profile-sidebar"], [id^="enhancer-container-element"]'
        );
        toRemove.forEach((el) => el.parentElement?.removeChild(el));
        return container.innerHTML;
    } catch {
        return input;
    }
};
